<style scoped>
.auto-table table.v-table thead td:not(:nth-child(1)),
.auto-table table.v-table tbody td:not(:nth-child(1)),
.auto-table table.v-table thead th:not(:nth-child(1)),
.auto-table table.v-table tbody th:not(:nth-child(1)),
.auto-table table.v-table thead td:first-child,
.auto-table table.v-table tbody td:first-child,
.auto-table table.v-table thead th:first-child,
.auto-table table.v-table tbody th:first-child {
    padding: 0 3px;
}
</style>
<template>
  <div class="auto-table">
      <v-snackbar
      v-model="snackbar"
      :timeout="3000"
      top="top"
      vertical="vertical"
      >
      {{ snackbarText }}
      <v-btn
      color="pink"
      flat
      @click="snackbar = false"
      >
      Close
    </v-btn>
  </v-snackbar>

    <v-toolbar flat color="white">
      <!-- <v-toolbar-title>My CRUD</v-toolbar-title> -->
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="800px">
        <template v-slot:activator="{ on }">
          <v-btn dark class="mb-2" v-on="on" v-on:click="createRow()">{{ row.multipleText}} </v-btn>
        </template>
        <v-card>
          <!-- <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title> -->
          <v-card-text>
            <v-container grid-list-md>
              <dynamic-form :details="details" :row="activeRow" :stepper="stepper" />
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save()">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <table class="v-datatable v-table theme--light" width="100%">
      <thead>
        <tr>
          <th :style="header.style" class="column text-xs-left" v-for="(header, index) in headers" :key="index">
            {{ header.text }}
          </th>
          <th>
            Actions
          </th>
        </tr>
      </thead>
      <tbody v-if="this.details">
        <tr v-for="(item, index) in items" :key="index" class="data-item">
          <td :style="header.style" :class="header.class" valign="middle" v-for="(header, indexColumn) in headers" :key="indexColumn">
            <span v-if="typeof header.actions != 'undefined'">
              <v-btn depressed small color="primary" v-for="action in header.actions" v-on:click="performAction(action, item)">{{ action.label }}</v-btn>
            </span>
            <span v-else v-on:click="edit(item.row)">
              {{ item[header.value] }}
              <!-- {{ getSafeValue(item[header.value], item.item) }} -->
            </span>
              <!-- <v-runtime-template v-if="item[header.value]" :template="'<span>' + item[header.value] + '</span>'" /> -->
          </td>
          <td>
            <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
        </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>

let template = "";
// { text: 'Actions', value: 'name', sortable: false }
import DynamicForm from '@/components/charts/form/dynamic-form/chart.vue';
import ApiService from '@/services/api.service';
import VRuntimeTemplate from "v-runtime-template";
import {
  upsertContent, getContent, createContent, getChildrenContent, requestSignature
}
from '@/models/freedomain';
import guid from '@/lib/guid';
import safeEval from 'notevil';
  export default {
    props: ['chart', 'details', 'row', 'stepper', 'detailIndex'],
    data: () => ({
      activeRow: null,
      requestSignature: {
        dialog: {}
      },
      snackbar: false,
      snackbarText: "",
      dialog: false,
      domains: [],
      items: [],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0
      },
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0
      }
    }),
    components: {
      'v-runtime-template': VRuntimeTemplate,
      'dynamic-form': DynamicForm
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },
      headers() {
        // console.log("this.details.headers", this.details.headers);
        return this.details.headers;
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      }
    },
    mounted () {
      this.loadData();
      // console.log("mounted", this.details);
      // this.domains = getChildrenContent(this.details.tableName, this.chart.domain._id);
    },
    created () {
      //console.log("mounted");
      //console.log("this.stepper", this.stepper);
      this.initialize()
    },

    methods: {
      async performAction(action, item) {
        console.log("action", action);
        console.log("item", item);

        this.applyRowProperties(item);

        if(typeof action.successMessage == "undefined") {
          action.successMessage = "Success ";
        }
        if(typeof action.errorMessage == "undefined") {
          action.errorMessage = "Error ";
        }

        let data = JSON.parse(JSON.stringify(item));
        let domain = createContent(data);
        domain.content = data;
        try {
          domain = await requestSignature(item.tableName, domain);
          this.snackbarText = action.successMessage;
          this.snackbar = true;
        } catch(err) {
          this.snackbarText = action.errorMessage;
          this.snackbar = true;

        }
      },
      getSafeValue(template, item) {
        try {
          // if(typeof item.template != "undefined")
          if(template) {
            console.log("item", item);
            console.log("stepper", this.stepper);
            console.log("item.template", template);
            const result = safeEval(template, {item: item, stepper: this.stepper});
            console.log("executed", result);
            return result;
          }

        } catch(err) {
          // console.log("template", template);
          console.log("err", err);
        }

        // if(!template) {
        //   return '';
        // }

        return template;
      },
      applyRowProperties(row) {
        if(typeof row.id == "undefined") {
          row.id = guid.createId('signatures');
        }
        row.openId = row.id;
        if(typeof row.openCode == "undefined") {
          row.openCode = Math.floor(1000 + Math.random() * 9000);
        }
        row.foreignId = this.chart.domain._id;
        row.tableName = this.details.tableName;
        return row;

      },
      edit(row) {

        this.activeRow = row;
        console.log("this.activeRow", this.activeRow);
        this.dialog = true;
      },
      createRow() {
        this.activeRow = JSON.parse(JSON.stringify(this.row));
        this.applyRowProperties(this.activeRow);
        this.activeRow.id = guid.createId('signatures');
        // var a = Math.floor(100000 + Math.random() * 900000);
        // a = String(a);
        // a = a.substring(0,4);
        // alert( "valor:" +a );
      },
      loadData() {

        for(let i = 0; i < this.details.rows.length; i++) {
          let item = this.details.rows[i];
          let d = {};
          if(typeof item.id != "undefined") {
            d.id = item.id;
          }

          d.row = item;
          for(let j = 0; j < item.elements.length; j++) {
            if(typeof item.elements[j].template == "undefined") {
              d[item.elements[j].name] = item.elements[j].model;
            }
          }
          for(let j = 0; j < item.elements.length; j++) {
            if(typeof item.elements[j].template != "undefined") {
              d[item.elements[j].name] = this.getSafeValue(item.elements[j].template, d);
            }
          }

          if(typeof this.items[i] != "undefined") {
            this.items[i] = d;
          } else {
            this.items.push(d);
          }

        }

        console.log("this.items", this.items);
      },
      initialize () {
      },
      editItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.desserts.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.desserts.splice(index, 1)
      },

      close () {
        this.dialog = false
        // setTimeout(() => {
        //   this.editedItem = Object.assign({}, this.defaultItem)
        //   this.editedIndex = -1
        // }, 300)
      },
      save () {
        if(this.activeRow) {
          const index = this.details.rows.findIndex(x => x.id === this.activeRow.id);
          if(index >= 0) {
            this.details.rows[index] = Object.assign({}, this.activeRow);
          } else {
            this.details.rows.push(Object.assign({}, this.activeRow));
          }
          // console.log("index", index);

          this.activeRow = null;
        }


        this.loadData();

        console.log("count", this.details.rows.length);
        console.log("detailIndex", this.detailIndex);
        console.log("details", this.details);
        console.log("rows", this.details.rows);
        console.log("chart.domain", this.chart.domain);


        this.chart.domain.content.steps[this.detailIndex].details = this.details;


        // if (this.editedIndex > -1) {
        //   Object.assign(this.desserts[this.editedIndex], this.editedItem)
        // } else {
        //   this.desserts.push(this.editedItem)
      // }
        this.close()
      }
    }
  }
</script>
